import React from 'react'
import SavingsAccountForm from './Components/SavingsAccountForm'

const SavingsAccount = () => {
    return (
        // {/* x---------------------------------x SavingsAccount Form x---------------------------------x */ }
        <div className="grid grid-cols-1 gap-2" >
            <div className="mx-0 px-0">
                <div className="h-full rounded-lg">
                    <div className="flex justify-between p-4">
                        <h2 className="text-dark sm:text-2xl text-lg font-semibold">Open New Savings Account</h2>
                    </div>
                    <div className="card-body sm:p-6 p-4 rounded-2xl text-dark">
                        {/* x---------------------------------x SavingsAccount Form Section x---------------------------------x */}
                        <SavingsAccountForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SavingsAccount